import React, { useEffect, useState } from "react";
import { forwardToNewDesign } from "../../utils/forwardToNewDesign";
import { useNavigate } from "react-router-dom";
import { postRequest } from "../../services/api/apiService";
import { getAuthToken } from "../../utils/auth";
import { afterPlatformConnect } from "../../utils/afterPlatformConnect";

const SnapchatAdsCallback = () => {
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (forwardToNewDesign()) return; // tunnel lancé depuis un autre client OneBotAds
    const queryParams = new URLSearchParams(window.location.search);
    const code = queryParams.get("code");
    const token = getAuthToken();

    if (!code) {
      setError("Authorization code missing.");
      return;
    }

    try {
      postRequest(
        "/api/ads-auth/snapchat/callback",
        { code },
        { Authorization: `Bearer ${token}` }
      )
        .then((response) => {
          if (response.success) {
            navigate(afterPlatformConnect());
          } else {
            setError("Failed to save Snapchat Ads account details.");
            navigate("/error");
          }
        })
        .catch((error) => {
          setError("Error during the Snapchat Ads authentication process.");
          navigate("/error");
        });
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  }, [navigate]);

  return <div>{error && <p>{error}</p>}</div>;
};

export default SnapchatAdsCallback;
